<!-- accordion-tabs -->

<template>
	<div :class="bemClass('tabs')">
		<template v-for="(item, index) in tabsArray" :key="item">
			<button
				:class="bemClass('button')"
				:aria-expanded="active == index + 1 ? 'true' : 'false'"
				@click="setActive(index)"
			>
			<slot name="icon"></slot>{{ item.label }}
			</button>
			<Transition name="accordion-tabs">
				<div
					v-if="active == index + 1"
					class="h-text--link"
					:class="bemClass('details')"
					v-html="item.text"
				></div>
			</Transition>
		</template>
	</div>
</template>

<script>
	export default {
		name: "accordion-tabs",
		data() {
			return {
				active: 1
			};
		},
		props: {
			blockClass: {
				type: String,
			},
			tabsData: {
				type: String
			}
		},
		computed: {
			tabsArray: function () {
				return this.tabsData ? JSON.parse(this.tabsData) : null;
			}
		},
		methods: {
			bemClass(element) {
				return `${this.blockClass}__${element}`
			},
			setActive(i) {
				this.active = i + 1;
			}
		}
	};
</script>
